import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetOneTaskById = createAsyncThunk(
  "Tasks/GetOneTaskById",
  async (parameters, { rejectWithValue }) => {
    try {
     
      const apiClient =  getApiClient();
      const response = await apiClient.post(
        "api/Tasks/GetOneTaskById",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetFilteredTasksCount = createAsyncThunk(
  "Tasks/GetFilteredTasksCount",
  async (parameters, { rejectWithValue }) => {
    try {
     
      const apiClient =  getApiClient();
      const response = await apiClient.post(
        "api/Tasks/GetFilteredTasksCount",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const Tasks = createSlice({
  name: "Tasks",
  initialState: {
    //------------- GetOneTaskById ---------------------
    TaskById: {},
    loadingTaskById: false,
    errorTaskById: null,
     //------------- GetFilteredTasksCount ---------------------
    TasksCount: 0,
    loadingTasksCount: false,
    errorTasksCount: null,
   
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetOneTaskById.pending, (state, action) => {
        state.loadingTaskById = true;
        state.TaskById = action.payload;
        state.errorTaskById = null;
      })
      .addCase(GetOneTaskById.fulfilled, (state, action) => {
        state.loadingTaskById = false;
        state.TaskById = action.payload;
      })
      .addCase(GetOneTaskById.rejected, (state, action) => {
        state.loadingTaskById = false;
        state.TaskById = action.payload;
      });
       builder
      .addCase(GetFilteredTasksCount.pending, (state, action) => {
        state.loadingTasksCount = true;
        state.TasksCount = action.payload;
        state.errorTasksCount = null;
      })
      .addCase(GetFilteredTasksCount.fulfilled, (state, action) => {
        state.loadingTasksCount = false;
        state.TasksCount = action.payload;
      })
      .addCase(GetFilteredTasksCount.rejected, (state, action) => {
        state.loadingTasksCount = false;
        state.TasksCount = action.payload;
      });
   
  },
});


export default Tasks.reducer;
